/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_LEGAL_LOCALE_DOCS_DETAILS_REQUEST,
  FETCH_LEGAL_LOCALE_DOCS_DETAILS_SUCCESS,
  FETCH_LEGAL_LOCALE_DOCS_DETAILS_FAILURE,
  FETCH_LEGAL_DOCUMENT_INFOS_REQUEST,
  FETCH_LEGAL_DOCUMENT_INFOS_SUCCESS,
  FETCH_LEGAL_DOCUMENT_INFOS_FAILURE,
  UPDATE_LEGAL_DOCUMENT_INFO_REQUEST,
  UPDATE_LEGAL_DOCUMENT_INFO_SUCCESS,
  UPDATE_LEGAL_DOCUMENT_INFO_FAILURE,
  FETCH_OEM_LEGAL_INFO_REQUEST,
  FETCH_OEM_LEGAL_INFO_SUCCESS,
  FETCH_OEM_LEGAL_INFO_FAILURE
} from "./LegalocaleDocumentsTypes";
const initialState = {
  loading: false,
  locales: [],
  legalDocumentInfo: [],
  legalInfo: [],
  message: "",
  error: "",
};

const LegallocaleDocumentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LEGAL_LOCALE_DOCS_DETAILS_REQUEST:
    case FETCH_LEGAL_DOCUMENT_INFOS_REQUEST:
    case UPDATE_LEGAL_DOCUMENT_INFO_REQUEST:
    case FETCH_OEM_LEGAL_INFO_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_LEGAL_LOCALE_DOCS_DETAILS_SUCCESS:
      return {
        loading: false,
        locales: action.payload,
        error: "",
      };
    case FETCH_LEGAL_LOCALE_DOCS_DETAILS_FAILURE:
      console.error("Error fetching legal locale documents:", action.payload);
      // Handle the error appropriately, e.g., log it or show a notification
      // You can also dispatch an error action if needed
      return {
        loading: false,
        locales: [],
        error: action.payload,
      };
    case FETCH_LEGAL_DOCUMENT_INFOS_SUCCESS:
      return {
        ...state,
        legalDocumentInfo: action.payload,
      };
    case FETCH_LEGAL_DOCUMENT_INFOS_FAILURE:
      console.error("Error fetching legal document infos:", action.payload);
      return {
        ...state,
        legalDocumentInfo: [],
        error: action.payload,
      };
    case UPDATE_LEGAL_DOCUMENT_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        message: "Legal document information updated successfully.",
      };
    case UPDATE_LEGAL_DOCUMENT_INFO_FAILURE:
    case FETCH_OEM_LEGAL_INFO_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_OEM_LEGAL_INFO_SUCCESS:
      return{
        ...state,
        loading: false,
        legalInfo: action.payload,
      }
    default:
      return state;
  }
};

export default LegallocaleDocumentsReducer;
